'use client';

import React from 'react';

import R2Image from '@/components/ui/R2Image';

interface DropdownTriggerButtonProps {
  onClick: () => void;
  label: string;
  isActive: boolean;
  iconPath?: string;
  iconAlt?: string;
  iconClassName?: string;
  iconWidth?: number;
  iconHeight?: number;
  minWidth?: string;
  disabled?: boolean;
  className?: string;
  ariaLabel?: string;
  role?: string;
}

const DropdownTriggerButton: React.FC<DropdownTriggerButtonProps> = ({
  onClick,
  label,
  isActive,
  iconPath = '/images/specialists/arrow-down.svg',
  iconAlt = 'V',
  iconClassName = '',
  iconWidth = 12,
  iconHeight = 12,
  minWidth = 'min-w-0  ',
  disabled = false,
  className = '',
  ariaLabel,
  role,
}) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className={`flex items-center justify-between gap-2 sm:gap-3 ${minWidth} rounded-lg border px-2.5 py-1.5 text-xs transition-all sm:px-3 sm:py-2.5 sm:text-sm ${className} ${disabled ? 'border-theme-disabled cursor-not-allowed opacity-40' : isActive ? 'border-theme-action-primary text-theme-action-primary font-normal' : 'border-theme-disabled'}`}
    type="button"
    aria-label={ariaLabel || label}
    role={role}
  >
    <span className="text-nowrap">{label}</span>
    <R2Image
      path={iconPath}
      alt={iconAlt}
      width={iconWidth}
      height={iconHeight}
      className={iconClassName}
    />
  </button>
);

export default DropdownTriggerButton;
